var map = {
	"./esenin@256.webp": 958,
	"./gallium@256.webp": 1991,
	"./matem@256.webp": 7151,
	"./physics@256.webp": 5798,
	"./pt@256.webp": 2889,
	"./tvorog@256.webp": 5438,
	"./universe-say@256.webp": 5385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2980;